// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"35536681","239":"6fc58295","453":"66a41f5c","455":"d776bffc"}[chunkId] + ".chunk.js";
};